import React, { useState } from 'react';

import { CheckCircleBoldIcon, ChevronDownIcon, ChevronUpIcon } from '@/components/Icon';
import { colors } from '@/const/colors';

const AccompanyingGuideView = () => {
  const [isClick, setIsClick] = useState<Record<string, boolean>>({
    show: false,
  });

  const onClickIcon = (type: string) => {
    setIsClick((prevState) => ({
      ...prevState,
      [type]: !prevState[type],
    }));
  };

  return (
    <div>
      <div className="flex flex-col items-center pt-8 bg-grey-1">
        <div className="flex justify-center items-center max-w-[280px] w-[76px] h-[54px]">
          <img
            src="https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/purchase-compaion-guide.png"
            alt="구매 동행 서비스 트럭 이미지"
            className="w-full"
          />
        </div>
        <div className="items-center justify-center">
          <p className="text-grey-7 text-[14px] font-medium text-center">
            화물차 구매가 망설여지거나
            <br className="sm280:block sm360:block sm680:hidden" />
            구매 절차에 도움이 필요하신 분이라면
          </p>
          <p className="pt-2 pb-8 text-2xl font-bold text-center text-grey-10">
            구매 동행 서비스로 <br className="sm280:block sm360:block sm680:hidden" />
            차량을 안전하게 구매하세요
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-center gap-4 items-center bg-grey-1  px-[34px] xxs:px-4">
        <div className="flex flex-col gap-4 bg-grey-0 p-5 rounded-[12px] w-full">
          <div className="flex flex-row items-center justify-center gap-2 font-bold sm280:flex-col">
            <div className="flex justify-center w-6 h-6 font-bold rounded-full bg-primary-2 text-primary-10">1</div>
            <div className="text-grey-10">차량 진단 평가 서비스</div>
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            직트럭 협력 진단 평가사가 직접 방문
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            사고·누유 등 전체적인 차량 상태 점검
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            차량 검사 후 진단 평가서 제공
          </div>
          <div className="flex justify-center text-primary-9 text-[13px] gap-1 items-center">
            <div className="max-w-[280px]">
              <CheckCircleBoldIcon width={14} height={14} />
            </div>
            <p>
              차량 구매 전 <span className="font-semibold">기본적인 점검</span>만 필요하신 분에게 적합
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-4 bg-grey-0 p-5 rounded-[12px] w-full">
          <div className="flex flex-row items-center justify-center gap-2 font-bold sm280:flex-col">
            <div className="flex justify-center w-6 h-6 font-bold rounded-full bg-primary-2 text-primary-10">2</div>
            <div className="text-grey-10">차량 구매 원스톱 서비스</div>
          </div>
          <div className="flex justify-center font-semibold text-[13px]">
            차량 검수·계약·이전서류·행정절차를 한번에 해결
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            사고·누유 등 전체적인 차량 상태 점검
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            수리 비용 산출 및 적절한 금액 협의
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            차량 계약·이전 서류 절차 안내
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            차량 대금·저당·압류 해지 등 행정 절차 지원
          </div>
          <div className="flex justify-center bg-grey-1 rounded-[12px] text-grey-9 text-[15px] p-3 font-semibold">
            10만원 이내의 차량 탁송 서비스 지원
          </div>
          <div className="flex justify-center text-primary-9 text-[13px] gap-1 items-center">
            <div className="max-w-[280px]">
              <CheckCircleBoldIcon width={14} height={14} />
            </div>
            <p>
              차량 구매에 필요한 <span className="font-semibold">모든 절차를 한 번에 해결</span>
              하고 싶으신 분에게 적합
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2 bg-grey-0 p-5 rounded-[12px] w-full mb-8 text-[16px]">
          <dl className="flex justify-between">
            <dt>수수료 안내</dt>
            <dd className="flex font-medium cursor-pointer" onClick={() => onClickIcon('show')}>
              {isClick.show ? <ChevronUpIcon color={colors.grey[6]} /> : <ChevronDownIcon color={colors.grey[6]} />}
            </dd>
          </dl>
          {!!isClick.show && (
            <div className="flex flex-col gap-[8px] justify-between text-grey-8 border-t border-grey-4">
              <dl className="flex justify-between mt-2 sm280:flex-col sm280:items-start">
                <dt>차량 진단 평가 서비스</dt>
                <dd className="font-semibold">25 ~ 30만원</dd>
              </dl>
              <dl className="flex justify-between sm280:flex-col sm280:items-start">
                <dt>차량 구매 원스톱 서비스</dt>
                <dd className="font-semibold">50만원</dd>
              </dl>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccompanyingGuideView;
